<template>
  <div class="domain-select">
    <div class="domain-select__header">
      <div class="row">
        <div class="col-12 col-md-4">
          <div class="domain-select__header-item typography--body-3 typography--color-secondary typography--font-weight-bold">
            {{ $t('evaluations.domain_select.header.title') }}
          </div>
        </div>

        <div class="col-12 col-md-8">
          <div class="domain-select__header-item typography--caption typography--color-secondary text-right">
            {{ $t('evaluations.domain_select.header.description') }}
          </div>
        </div>
      </div>
    </div>

    <div class="domain-select__option-list">
      <DomainSelectOption
        v-for="domain in domains"
        v-bind:key="domain.id"
        v-bind:domain="domain"
        v-bind:loading="loading"
        v-bind:is-selected="isSelectedDomain(domain.id)"
        v-on:domain-option-clicked="$emit('domain-option-clicked', domain.id)"
      />
    </div>
  </div>
</template>

<script>
  import DomainSelectOption from './DomainSelectOption';

  export default {
    name: 'domain-select',

    components: {
      DomainSelectOption,
    },

    props: {
      domains: {
        type: Array,
        default: () => ([]),
      },
      selectedDomainIds: {
        type: Array,
        default: () => ([]),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      isSelectedDomain(domainId) {
        return this.selectedDomainIds.indexOf(domainId) !== -1;
      },
    },
  };
</script>

<style lang="scss">
  .domain-select {
    .domain-select__header {
      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #d9d9d9;
    }

    .domain-select__header-item {
      padding-top: 3px;
      padding-bottom: 3px;
    }

    .domain-select__option-list {
      padding-top: 10px;
      padding-bottom: 10px;
      margin-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/evaluations/components/DomainSelect.vue